import React, { useContext } from "react";
import {
  ADD_USER_TYPE,
  AddMembersContext,
  IAddMembersContext,
  SelectedUserType,
  useTranslation,
} from "hhn-commons";
import { IUserInfo } from "@home-health-notify/domain";
import { ReferralTextField } from "../AddMember.style";
import { ActionButtons } from "./actionButtons/ActionButtons";
import { ImmutableChat } from "@home-health-notify/domain/build/chat/ImmutableChat";

type AddUserListItemActionsProps = {
  userInfo: IUserInfo;
  hasReferral: boolean;
  canSendReferral: boolean;
  chat: ImmutableChat | undefined;
};

const AddUserListItemActions = ({
  userInfo,
  hasReferral,
  canSendReferral,
  chat,
}: AddUserListItemActionsProps) => {
  const {
    selectedUsers,
    onAddUser,
    onSendReferral,
    addReferralMsg,
  }: IAddMembersContext = useContext(AddMembersContext);
  const { t } = useTranslation();
  const tNs = (key: string) => t(key, { ns: "message" });

  const userSelected = selectedUsers.find(
    (user: SelectedUserType) => user.id === userInfo.id,
  );
  const isUserReferralSelected =
    userSelected && userSelected.type === ADD_USER_TYPE.REFERRAL;

  return (
    <>
      <ActionButtons
        userInfo={userInfo}
        onAddUser={onAddUser}
        onSendReferral={onSendReferral}
        userSelected={userSelected}
        hasReferral={hasReferral}
        canSendReferral={canSendReferral}
        chat={chat}
      />
      {canSendReferral && isUserReferralSelected && (
        <ReferralTextField
          fullWidth
          label={tNs("referral.messageInput")}
          variant="standard"
          placeholder={tNs("referral.placeholderText")}
          slotProps={{
            htmlInput: {
              "data-testid": "text-referral-member-msg",
            },
          }}
          value={userSelected!.refMsg}
          onChange={e => {
            addReferralMsg(userInfo, e.target.value);
          }}
        />
      )}
    </>
  );
};

export default AddUserListItemActions;
